export const TOUCH_ENTER_DELAY = 10;
export const LEAVE_TOUCH_DELAY = 3500;
